import { useContext, useEffect, useRef } from 'react';
import { useState } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
    useNavigate,
    useParams,
} from 'react-router-dom';
import DocProcessing from 'components/ai-chat-board/DocProcessing';
import { useSelector } from 'react-redux';
import StateContext from 'constants/StateContext';


function DocumentProcessing({ setShowAIChatbotComponent }: any) {
    const { setParamsId, handleNewChatButton, handleGetConversation_2, setHover, } = useContext<any>(StateContext);
    //variables
    const navigate = useNavigate();
    const iframeRef: any = useRef(null);
    const [showModal, setShowModal] = useState(false)
    const params = useParams();
    const [readOnly, setReadOnly] = useState<boolean>(params.id !== "new-chat" ? true : false);
    const docuMateCounter = useSelector((state: any) => state.counter.docuMateCounter);
    const [pressed, setPressed] = useState<boolean>(false);
    const hisoryCalled = useSelector((state: any) => state.counter.hisoryCalled);
    if (!params || !params.id || params.id === 'undefined') {
        navigate(`/document-processing/new-chat`);
    }
    // const [comparisonDocFile, setComparisonDocFile] = useState("");
    // const [synthesizeDocFile, setSynthesizeDocFile] = useState("");
    // const [comparisonDocName, setComparisonDocName] = useState("");
    // const [synthesizeDocName, setSynthesizeDocName] = useState("");
    // const [modalOptionCompare, setModalOptionCompare] = useState("")
    // const [modalOptionSynthesize, setModalOptionSynthesize] = useState("")
    // const [showModalCompare, setShowModalCompare] = useState(false)
    // const [showModalSynthesize, setShowModalSynthesize] = useState(false)


    // const handleNewChatButton = () => {
    //     dispatch(handleDocuMateUserQuery([]))
    //     dispatch(handleDocuMateCounter(false));
    //     setBase64("");
    //     setComparisonDocFile("")
    //     setSynthesizeDocFile("")
    //     setShowShare(false)
    //     setShowModal(false)
    //     setShowModalCompare(false)
    //     setShowModalSynthesize(false)
    //     setInputFileName("")
    //     setModalOption("")
    //     setModalOptionCompare("")
    //     setModalOptionSynthesize("")
    //     setUserQuery([])
    //     setAnswer([])
    // };

    // useEffect(() => {
    //     navigate(`/document-processing/${params.id}`);
    //     if (params.id !== 'new-chat' && params.id !== undefined) {
    //         handleGetConversation_2(params.id, localStorage.getItem('username'));
    //     }
    //     // else {
    //     //     handleNewChatButton();
    //     // }   
    // }, []);


    useEffect(() => {
        if (docuMateCounter) {
            handleNewChatButton();
        }
    }, [docuMateCounter])

    useEffect(() => {
        const handleBeforeUnload = () => {
            sessionStorage.setItem("reloaded", "true");
        };

        window.addEventListener("beforeunload", handleBeforeUnload);

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, []);

    useEffect(() => {
        window.onpopstate = e => {
            setPressed(true);
        };
    });
    const tempFunc = () => {
        if (params.id) {
            console.log("called here")
            handleGetConversation_2(params.id, localStorage.getItem('username'));
        }
        setPressed(false);
    }
    useEffect(() => {
        if (params.id !== 'new-chat' && params.id !== undefined && hisoryCalled) {
            // setHover(null);
            tempFunc();
        }
    }, [params.id])

    useEffect(() => {
        const handleBackButton = () => {
            setHover(null); // Reset state when the back button is clicked
        };

        window.addEventListener("popstate", handleBackButton);

        return () => {
            window.removeEventListener("popstate", handleBackButton);
        };
    }, []);

    const notify = (toastmsg: any) => {
        return toast(toastmsg, {
            position: 'bottom-center',
            style: {
                backgroundColor: '#F1F1F1', // Grey background
            }
        });
    };

    useEffect(() => {
        if (params.id) {
            setParamsId(params.id)
        }
    }, [params])


    return (
        <>

            <main className="content-wrapper" >

                <DocProcessing
                    notify={notify}
                    readOnly={readOnly}
                    showModal={showModal}
                    setShowModal={setShowModal}
                    iframeRef={iframeRef}
                />
            </main>
        </>
    );
}

export default DocumentProcessing;
